/* eslint-disable react/no-unescaped-entities */
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';

const Preloader = ({ height = 400 }: any): JSX.Element => {
    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: height,
                minWidth: { xs: 250, sm: 400 },
            }}
            justifyContent={'center'}
            minHeight={'300px'}
            alignItems={'center'}
        >
            <CircularProgress />
        </Box>
    );
};

export default Preloader;
